export const DUPLICATED_DATASETS = 'DUPLICATED_DATASETS';

export default {
  DUPLICATED_DATASETS
};
